import { EditPage, EditPageTextField, EditPageCheckbox, EditPagePanel } from './../../../common/EditPage';
import { update, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

const LLMModelsEdit = () => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();
    const { model_id } = useParams();
    
    useEffect(() => {
        getOne('/admin/ai/llm-models/', model_id).then(response => {
            setData(response.data.data);
        });
    }, []);

    const handleSave = () => {
        update('/admin/ai/llm-models/', model_id, {data: data}).then(response => {
            toast.success("LLM Model updated successfully", {});
            navigate('/ai/llm-models');
        }).catch(error => {
            toast.error("Error updating LLM Model: " + error.message, {});
        });
    }
    
    const handleCancel = () => {
        navigate('/ai/llm-models');
    }
    
    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }
    
    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Edit LLM Model" >
                <EditPagePanel className="col-lg-6">
                    <EditPageTextField label="Provider" id="provider" onChange={ onChange } value={ data.provider } placeholder="e.g., openai, anthropic, google" />
                    <EditPageTextField label="Model" id="model" onChange={ onChange } value={ data.model } placeholder="e.g., gpt-4o, claude-3-opus" />
                    <EditPageTextField label="Capabilities" id="capabilities" onChange={ onChange } value={ data.capabilities } placeholder="e.g., text, voice or text,voice" />
                    <EditPageTextField label="Cost" id="cost" onChange={ onChange } value={ data.cost } placeholder="Cost per usage" type="number" step="0.000001" />
                    <EditPageCheckbox label="Enabled" id="enabled" onChange={ onChange } value={ data.enabled } />
                </EditPagePanel>
            </EditPage>
        </div>
    );
};

export default LLMModelsEdit;

